import { render, staticRenderFns } from "./ApplicationStudent.vue?vue&type=template&id=68ebb3ec&scoped=true&"
import script from "./ApplicationStudent.vue?vue&type=script&lang=js&"
export * from "./ApplicationStudent.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationStudent.vue?vue&type=style&index=0&id=68ebb3ec&prod&lang=scss&"
import style1 from "./ApplicationStudent.vue?vue&type=style&index=1&id=68ebb3ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ebb3ec",
  null
  
)

export default component.exports